var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "container content-padding" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-8 offset-sm-2 col-12" }, [
        _c("h2", [_vm._v(_vm._s(_vm.$t("message.recruting.title")))]),
        _vm._v(" "),
        _vm.jobPost
          ? _c("div", { staticClass: "card panel-white" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("b", [_vm._v(_vm._s(_vm.$t("message.recruting.code")))]),
                    _vm._v(" #" + _vm._s(_vm.jobPost.code) + "\n            ")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.jobPost.title) +
                        "\n            "
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-4 text-left" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("message.recruting.description")))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.jobPost.description) +
                        "\n            "
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-4 text-left" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("message.recruting.interviews")))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row social-box" },
                  [
                    _vm._l(_vm.jobPost.job_users, function(item, index) {
                      return [
                        item.job_user
                          ? _c("div", { staticClass: "col-6 text-center" }, [
                              _c("div", { staticClass: "box card" }, [
                                _c("div", { staticClass: "box-title" }, [
                                  _c("img", {
                                    staticClass: "card-img-top",
                                    staticStyle: {
                                      height: "180px",
                                      width: "auto"
                                    },
                                    attrs: { src: item.job_user.picture }
                                  }),
                                  _vm._v(" "),
                                  _c("h3", { staticClass: "mt-3" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(item.job_user.prefix_name) +
                                        " " +
                                        _vm._s(item.job_user.name)
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "box-text text-left" },
                                  [
                                    _c("span", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("message.recruting.age")
                                          )
                                        )
                                      ]),
                                      _vm._v(
                                        ": " +
                                          _vm._s(
                                            _vm.calculateAge(
                                              item.job_user.birth_date
                                            )
                                          )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("span", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "message.recruting.introduce"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(
                                        ": " + _vm._s(item.job_user.introduce)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("span", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "message.recruting.working_experience"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(
                                        ": " +
                                          _vm._s(
                                            item.job_user.working_experience
                                          )
                                      )
                                    ])
                                  ]
                                )
                              ])
                            ])
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                )
              ])
            ])
          : _c("div", { staticClass: "row" }, [_vm._m(0)])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col text-center" }, [
      _c("div", { staticClass: "mb-3" }, [
        _c("i", { staticClass: "fal fa-times-circle -status-alert fa-3x" })
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("Not Found")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07c52024", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07c52024","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/recruting/RecrutingDetail.vue
// module id = 2357
// module chunks = 0